import React from 'react'
import {usePage} from '@salesforce/commerce-sdk-react'
import {Page} from '@salesforce/commerce-sdk-react/components'
import RTE from '@consteed/frontend/components/pageDesigner/RTE'
import Model3D from '@consteed/frontend/components/pageDesigner/Model3D'
import {
    ImageTile,
    ImageWithText,
    LinkTile
} from '@salesforce/retail-react-app/app/page-designer/assets'
import {
    Carousel,
    MobileGrid1r1c,
    MobileGrid2r1c,
    MobileGrid2r2c,
    MobileGrid2r3c,
    MobileGrid3r1c,
    MobileGrid3r2c
} from '@consteed/overrides/page-designer/layouts'
import ImageTextButton from '@consteed/frontend/components/pageDesigner/ImageTextButton'
import MainBanner from '@consteed/frontend/components/pageDesigner/MainBanner'
import ContactTiles from '@consteed/frontend/components/pageDesigner/ContactTiles'
import LandingPageHero from '@consteed/frontend/components/pageDesigner/LandingPageHero'
import LandingPageQuestions from '@consteed/frontend/components/pageDesigner/LandingPageQuestions'
import LandingPageDiscover from '@consteed/frontend/components/pageDesigner/LandingPageDiscover'
import GeneralVideo from '@consteed/frontend/components/pageDesigner/GeneralVideo'
import {HTTPError, HTTPNotFound} from '@salesforce/pwa-kit-react-sdk/ssr/universal/errors'
import PropTypes from 'prop-types'
import LandingPageInfoWith3DModel from '@consteed/frontend/components/pageDesigner/LandingPageInfoWith3DModel'
import LandingPageDataSlider from '@consteed/frontend/components/pageDesigner/LandingPageDataSlider'

const PAGEDESIGNER_TO_COMPONENT = {
    'commerce_assets.mainBanner': MainBanner,
    'commerce_assets.imageAndText': ImageWithText,
    'commerce_assets.editorialRichText': RTE,
    'commerce_assets.photoTile': ImageTile,
    'commerce_layouts.carousel': Carousel,
    'commerce_layouts.mobileGrid1r1c': MobileGrid1r1c,
    'commerce_layouts.mobileGrid2r1c': MobileGrid2r1c,
    'commerce_layouts.mobileGrid2r2c': MobileGrid2r2c,
    'commerce_layouts.mobileGrid2r3c': MobileGrid2r3c,
    'commerce_layouts.mobileGrid3r1c': MobileGrid3r1c,
    'commerce_layouts.mobileGrid3r2c': MobileGrid3r2c,
    'custom_assets.imageTextButton': ImageTextButton,
    'custom_assets.contactTiles': ContactTiles,
    'custom_assets.landingPageHero': LandingPageHero,
    'custom_assets.landingPageDataSlider': LandingPageDataSlider,
    'custom_assets.landingPageInfoWith3DModel': LandingPageInfoWith3DModel,
    'custom_assets.landingPageQuestions': LandingPageQuestions,
    'custom_assets.landingPageDiscover': LandingPageDiscover,
    'custom_assets.generalVideo': GeneralVideo,
    'custom_assets.model3D': Model3D,
    'custom_assets.pwaLinkTile': LinkTile
}
const usePageDesigner = (props) => {
    const {data: page, error} = usePage({
        parameters: {pageId: props?.pageId, aspectAttributes: props?.aspectAttributes}
    })

    if (error) {
        if (props.returnNullOnError) {
            return null
        }
        let ErrorClass = error.response?.status === 404 ? HTTPNotFound : HTTPError
        throw new ErrorClass(error.response?.statusText)
    }

    return <Page page={page} components={PAGEDESIGNER_TO_COMPONENT} />
}
usePageDesigner.propTypes = {
    pageId: PropTypes.string,
    aspectAttributes: PropTypes.object,
    returnNullOnError: PropTypes.bool
}

export default usePageDesigner
